import { ContactPartnerItemsInterface, ContactPartnerDetailsItemInterface } from '../interfaces/internationalContact';

export const ContactPartnerExample: ContactPartnerItemsInterface = {
    items: [
        {
            ' VKG': null,
            'Country Name GB': null,
            'Country Short': null,
            unid: null,
        },
    ],
};

export const ContactPartnerDetailsExmaple: ContactPartnerDetailsItemInterface = {
    City: null,
    Email: null,
    Fax: null,
    Mobile: null,
    Name: null,
    Street: null,
    VKG: null,
    ZIP: null,
    attachments: {
        admPhoto0: null,
    },
    www: null,
    haendler: [
        {
            City: null,
            Email: null,
            Fax: null,
            Mobile: null,
            Name: null,
            Street: null,
            VKG: null,
            ZIP: null,
            attachments: {
                admPhoto0: null,
            },
            www: null,
        },
    ],
    merchants: [
        {
            city: null,
            email: null,
            fax: null,
            phone: null,
            name: null,
            street: null,
            VKG: null,
            zip: null,
            www: null,
        },
    ],
    contacts: [
        {
            sectionTitle: null,
            merchants: [
                {
                    city: null,
                    email: null,
                    fax: null,
                    phone: null,
                    name: null,
                    street: null,
                    VKG: null,
                    zip: null,
                    www: null,
                },
            ],
        },
    ],
};
